import React from 'react';
import type { FC } from 'react';
import { Text, Box, Link, UnorderedList, Learn } from '@wix/cli-ui-kit';
import type { IPackageManager } from '@wix/package-manager';

export const FinishedSuccessfullyMessage: FC<{
  packageManager: IPackageManager;
}> = ({ packageManager }) => {
  return (
    <Box
      borderColor="blue"
      borderStyle="round"
      flexDirection="column"
      paddingY={1}
      paddingX={3}
      gap={1}
      marginLeft={-2}
      marginTop={1}
    >
      <Text bold>Next Steps:</Text>

      <UnorderedList gap={1}>
        <UnorderedList.Item marker="👟">
          <Text>Start developing</Text>
          <Text skin="info">{`${packageManager.getRunCmd()} dev`}</Text>
        </UnorderedList.Item>

        <UnorderedList.Item marker={<Learn />}>
          <Text>For guides and API references visit our</Text>
          <Link skin="info" url="https://dev.wix.com/docs/go-headless">
            documentation
          </Link>
        </UnorderedList.Item>

        <UnorderedList.Item marker="💬">
          <Text>Join our</Text>
          <Link skin="info" url="https://discord.gg/wixstudio">
            Discord community
          </Link>
        </UnorderedList.Item>
      </UnorderedList>
    </Box>
  );
};
